import React from 'react'
import { DonationFormBLockClassNames } from './donationFormBlock.state'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import { expandableBlockClasses } from '../expandableBlock/expandableBlock.layout'
import { SharingLayout } from '../../../header/pageHeader/sharing.layout'
import { ReadSpeaker } from '../../../../readspeaker/readspeaker.widget'
import { State, renderReadSpeaker } from '../../../cmsPage.widget'
import { title } from 'process'
import { slugify } from '../../../../../../Shared/Frontend/utils/slugify'
import { htmlDecode } from '../../../utils/html'

export const donationBlockClasses: DonationFormBLockClassNames = {
  // DEFAULTS
  block: 'block block--donation',
  inview: 'inview',

  // BLOCK SPECIFIC
}

export const DonationBlockLayout = {
  Wrapper:(html:JSX.Element) => <>
    <div className="block__inner ls-container--l">
      <div className="block__layout">
        {html}
      </div>
    </div>
  </>,
  Inner:(p:{html: JSX.Element, expandables: JSX.Element, text:string, showHeader?:boolean, title:string, state: State}) => <>
    <div className='donation ls-container ls-gutter ls-spacing--s'>
      <div className='donation__inner'>
        <div className='donation__form'>
          {p.showHeader && <h2 id={slugify(htmlDecode(title))} className='donation__title title--m'>{p.title}</h2>}
          {p.html}
        </div>
      </div>
    </div>

    <div className='block__wrap'>
      <SharingLayout.Wrap>
        {renderReadSpeaker(p.state) == true && <ReadSpeaker keyId="a1" encodedUrl={encodeURI(window.location.href)} readElementId={'a11y-main'} />}
        <SharingLayout.Button />
        <SharingLayout.Popup />
      </SharingLayout.Wrap>

      <section className={getClassNameModern(expandableBlockClasses, "block") + " " + getClassNameModern(expandableBlockClasses, "inview")}>
        <div className={getClassNameModern(expandableBlockClasses, "inner")}>
          <header className={getClassNameModern(expandableBlockClasses, "header")}>
            <p className={getClassNameModern(expandableBlockClasses, "intro")} dangerouslySetInnerHTML={{ __html: p.text }} />
          </header>
          <div className={getClassNameModern(expandableBlockClasses, "content")}>
            {p.expandables}
          </div>
        </div>
      </section>
    </div>
  </>
}
